import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAngleUp = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 7,
	stroke: "#0050a0",
	viewBox: "0 0 10 7",
	width: 10,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m4.99672 1.54541-3.63637 3.63637m3.64-3.63637 3.63636 3.63637",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2
	})
});
export default SvgAngleUp;
